module.exports = __webpack_public_path__ + "static/media/fl_cast_sjkaplan.b4239d16.jpg";